import React, { useEffect, useState } from "react";
import {
  Package,
  Wrench,
  Users,
  ShoppingCart,
  RefreshCcw,
} from "lucide-react";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../context/AuthContext";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import { API_BASE_URL } from "../../config/api";


const AdminDashboard = () => {
  const { logout } = useAuth();
  const user = JSON.parse(localStorage.getItem("user"));

  const [range, setRange] = useState("monthly");
  const [loading, setLoading] = useState(false);

  const [stats, setStats] = useState({
    products: 0,
    parts: 0,
    orders: 0,
    repairs: 0,
    users: 0,
  });

  // ================= FETCH STATS =================
  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `${API_BASE_URL}/api/stats?range=${range}`
        );

        const data = await res.json();
        setStats(data);
      } catch (err) {
        console.error("Stats error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [range]);

  // ================= CHART DATA =================
  const chartData = [
    { name: "Produkte", value: stats.products },
    { name: "Pjesë", value: stats.parts },
    { name: "Porosi", value: stats.orders },
    { name: "Servise", value: stats.repairs },
    { name: "Përdorues", value: stats.users },
  ];

  const COLORS = ["#3b82f6", "#10b981", "#f97316", "#a855f7", "#ef4444"];

  const cards = [
    {
      label: "Produkte",
      value: stats.products,
      icon: <Package size={28} />,
      color: "from-blue-500 to-blue-600",
    },
    {
      label: "Pjesë",
      value: stats.parts,
      icon: <Wrench size={28} />,
      color: "from-green-500 to-green-600",
    },
    {
      label: "Porosi",
      value: stats.orders,
      icon: <ShoppingCart size={28} />,
      color: "from-orange-500 to-orange-600",
    },
    {
      label: "Servise",
      value: stats.repairs,
      icon: <RefreshCcw size={28} />,
      color: "from-purple-500 to-purple-600",
    },
    {
      label: "Përdorues",
      value: stats.users,
      icon: <Users size={28} />,
      color: "from-red-500 to-red-600",
    },
  ];

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      <main className="flex-1 ml-64 p-8">

        {/* HEADER */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">
              Admin Dashboard
            </h1>
            <p className="text-gray-500">
              Welcome, <b>{user?.username}</b>
            </p>
          </div>

          <select
            value={range}
            onChange={(e) => setRange(e.target.value)}
            className="px-4 py-2 border rounded-lg bg-white shadow"
          >
            <option value="day">Ditor</option>
            <option value="week">Javor</option>
            <option value="month">Mujor</option>
            <option value="year">Vjetor</option>
          </select>
        </div>

        {/* LOADING */}
        {loading && (
          <p className="text-gray-500 mb-4">Loading data...</p>
        )}

        {/* CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-5 mb-10">
          {cards.map((c, i) => (
            <div
              key={i}
              className={`p-5 rounded-2xl text-white shadow-lg bg-gradient-to-r ${c.color}`}
            >
              <div className="flex justify-between items-center">
                {c.icon}
                <span className="text-2xl font-bold">{c.value}</span>
              </div>
              <p className="mt-2 text-sm opacity-90">{c.label}</p>
            </div>
          ))}
        </div>

        {/* CHARTS */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

          <div className="bg-white p-5 rounded-2xl shadow">
            <h2 className="font-bold mb-4">Përmbledhje</h2>

            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={chartData}>
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Line
                  type="monotone"
                  dataKey="value"
                  stroke="#3b82f6"
                  strokeWidth={3}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>

          <div className="bg-white p-5 rounded-2xl shadow">
            <h2 className="font-bold mb-4">Shpërndarja</h2>

            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={chartData}
                  dataKey="value"
                  nameKey="name"
                  outerRadius={110}
                  label
                >
                  {chartData.map((_, index) => (
                    <Cell key={index} fill={COLORS[index]} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>

        </div>

      </main>
    </div>
  );
};

export default AdminDashboard;